import api from '../../helpers/axios'
export const state = {
    education: null,
    educations: []
};

export const getters = {
    education: (state) => state.education,
    educations: (state) => state.educations,
};

export const mutations = {
    setEducation(state, newValue) {
        state.education = newValue;
    },
    setEducations(state, newValue) {
        state.educations = newValue;
    },
};

export const actions = {

   createEducation(_,  data) {
        return new Promise((resolve,reject) => {
            api.post("/educations", data).then((res) => {
                if(res){
                    resolve(res.data.data)
                }
            }).catch((err) => {
                reject(err)
            })
        });
    },


    updateEducation(_, { id, data }) {
        return new Promise((resolve, reject) => {
            api.put("/educations/" + id, data).then((res) => {
                resolve(res.data.data);
            }).catch((err) => {
                reject(err);
            });
        });
    },



   deleteEducation(_, id) {
        return new Promise((resolve) => {
            api.delete("/educations/"+id).then((res) => {
                resolve(res.data.data)
            })
        });
    },



    fetchEducation({ commit }, {id}) {
        return new Promise((resolve,reject) => {
            api.get("/educations/"+id).then((res) => {
                commit("setEducation", res.data.data);
                resolve(res.data.data)
            }).catch(err=>{
                reject(err)
            })
        });
    },

    fetchEducations({ commit }, { name, site,level, isActive, page, limit, listType }) {
        let query = "?";

        if (listType) {
            query += `listType=${listType}&`;
        } else {
            query += `page=${page}&`;
            query += `limit=${limit}&`;
        }
        if (name) {
            query += `name=${name}&`;
        }
        if (site) {
            query += `site=${site}&`;
        } if (level) {
            query += `level=${level}&`;
        }
        if (isActive !== undefined) {
            query += `isActive=${isActive}&`;
        }
        return new Promise((resolve) => {
            api.get("/educations" + query).then((res) => {
                commit("setEducations", res.data.data);
                resolve(res.data.data);
            });
        });
    },


};
